import { render, staticRenderFns } from "./AudioPlayButton.vue?vue&type=template&id=2422e1e6&"
import script from "./AudioPlayButton.vue?vue&type=script&lang=js&"
export * from "./AudioPlayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports